import * as React from "react";
import { forwardRef } from "react";
const SvgPlus = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M50 10.5a4.5 4.5 0 0 0-4.5 4.5v30.5H15a4.5 4.5 0 0 0-4.5 4.5 4.5 4.5 0 0 0 4.5 4.5h30.5V85a4.5 4.5 0 0 0 4.5 4.5 4.5 4.5 0 0 0 4.5-4.5V54.5H85a4.5 4.5 0 0 0 4.5-4.5 4.5 4.5 0 0 0-4.5-4.5H54.5V15a4.5 4.5 0 0 0-4.5-4.5" />
  </svg>
);
const ForwardRef = forwardRef(SvgPlus);
export default ForwardRef;
